import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    id: _ctx.id,
    class: _normalizeClass(["w-full rounded-md text-left truncate", _ctx.computedDropDownItemStyle])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}